import { ImagePlus, Eye, QrCode, RefreshCcw, Maximize2, Minimize2 } from 'lucide-react';

/**
 * Preview action rail for Makeup Looks (upload, phone upload, compare, QR, fullscreen, reset).
 * All actions stay available in fullscreen so the toolbar fits the kiosk controls.
 */
export default function LooksActionsRail({
  canCompare = false,
  canDownload = false,
  isComparing = false,
  isFullscreen = false,
  onImport,
  onToggleCompare,
  onDownloadQr,
  onToggleFullscreen,
  onRequestReset,
}) {
  return (
    <div className="looks-actions-rail" role="toolbar" aria-label="Look actions">
      <div className="looks-actions-rail__group">
        <button
          type="button"
          className="looks-actions-rail__btn"
          aria-label="Change photo"
          title="Camera, upload, or phone QR"
          onClick={onImport}
        >
          <ImagePlus size={20} strokeWidth={2.1} />
        </button>
        <button
          type="button"
          className={`looks-actions-rail__btn${isComparing ? ' is-active' : ''}`}
          aria-label={isComparing ? 'Exit compare' : 'Compare looks'}
          title={isComparing ? 'Exit compare' : 'Compare original and applied looks'}
          aria-pressed={isComparing}
          disabled={!canCompare}
          onClick={onToggleCompare}
        >
          <Eye size={20} strokeWidth={2.1} />
        </button>
        <button
          type="button"
          className="looks-actions-rail__btn"
          aria-label="Download via QR"
          title="Download via QR"
          disabled={!canDownload}
          onClick={onDownloadQr}
        >
          <QrCode size={20} strokeWidth={2.1} />
        </button>
      </div>
      <div className="looks-actions-rail__divider" aria-hidden="true" />
      <div className="looks-actions-rail__group">
        <button
          type="button"
          className={`looks-actions-rail__btn${isFullscreen ? ' is-active' : ''}`}
          aria-label={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
          title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
          aria-pressed={isFullscreen}
          onClick={onToggleFullscreen}
        >
          {isFullscreen ? <Minimize2 size={20} strokeWidth={2.1} /> : <Maximize2 size={20} strokeWidth={2.1} />}
        </button>
        <button
          type="button"
          className="looks-actions-rail__btn looks-actions-rail__btn--reset"
          aria-label="Reset look"
          title="Reset look"
          onClick={onRequestReset}
        >
          <RefreshCcw size={20} strokeWidth={2.1} />
        </button>
      </div>
    </div>
  );
}
